import axios from 'axios';
import HttpHelpers from "../components/lib/Http/HttpHelpers";
import { saveAs } from 'file-saver';


export default class HttpService
{
    static async  downloadFile(url, filename, token) {
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/octet-stream', // Adjust content type as needed
            },
          });
      
          if (!response.ok) {
            var errMsgs = [response.statusText?? "Error"];
            errMsgs.push(response.status);
            return {"httpStatusCode": response.status, "hasError": true, "messages": errMsgs, "isRecordNotFound": false, "dataResult": null};

            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          const blob = await response.blob();
          saveAs(blob, filename);
          var msgs = [response.statusText?? "Ok"];
          msgs.push(response.status);
          return {"httpStatusCode": response.status, "hasError": false, "messages": msgs, "isRecordNotFound": false, "dataResult": null};

        } catch (err) {
            return {"httpStatusCode": "", "hasError": true, "messages": [err.name, err.message], "isRecordNotFound": false, "dataResult": null};
        }
      }

    static async get(domain, url, token)
    {
        try{
            var config = {method: 'GET'};
            if (token)
            {
                config.headers = {"Authorization": "bearer " + token};
            }
            var fullUrl = domain + url;
            const response = await axios( fullUrl, config);
            if (HttpHelpers.HttpStatusOk(response.status))
            {
                return {"httpStatusCode": response.status, "hasError": false, "messages": response.data.messages, "isRecordNotFound": response.data.isRecordNotFound, "dataResult": (response.data.data) ? response.data.data: response.data};
            }
            else 
            {
                var errMsgs = [response.statusText];
                errMsgs.push(response.data.messages);
                return {"httpStatusCode": response.status, "hasError": true, "messages": errMsgs, "isRecordNotFound": (!response.data) ? false: response.data.isRecordNotFound, "dataResult": (response.data.data) ? response.data.data: response.data};
            }
        }
        catch(err){
            return {"httpStatusCode": "", "hasError": true, "messages": [err.name, err.message], "isRecordNotFound": (!err.response.data) ? false: err.response.data.isRecordNotFound, "dataResult": null};
        }
        finally{

        }
    }


    static async getByFullUrl(fullUrl, token)
    {
        try{
            var config = {method: 'GET'};
            if (token)
            {
                config.headers = {"Authorization": "bearer " + token};
            }
            //var fullUrl = domain + url;
            const response = await axios( fullUrl, config);
            if (HttpHelpers.HttpStatusOk(response.status))
            {
                return {"httpStatusCode": response.status, "hasError": false, "messages": response.data.messages, "isRecordNotFound": response.data.isRecordNotFound, "dataResult": (response.data.data) ? response.data.data: response.data};
            }
            else 
            {
                var errMsgs = [response.statusText];
                errMsgs.push(response.data.messages);
                return {"httpStatusCode": response.status, "hasError": true, "messages": errMsgs, "isRecordNotFound": (!response.data) ? false: response.data.isRecordNotFound, "dataResult": (response.data.data) ? response.data.data: response.data};
            }
        }
        catch(err){
            return {"httpStatusCode": "", "hasError": true, "messages": [err.name, err.message], "isRecordNotFound": (!err.response.data) ? false: err.response.data.isRecordNotFound, "dataResult": null};
        }
        finally{

        }
    }


    static async postJson(domain, url, token, postObj, overrideConfig) {
        try {
            var config = (overrideConfig) ? overrideConfig: {method: 'POST'};
            if (token) {
                config = {
                    method: 'POST',
                    headers: {
                        "Authorization": "bearer " + token,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'              
                    }
                }
            }
            else 
            {
                config = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'   
                    }  
                }            
            };
            
            var fullUrl = domain + url;
            console.group("Posting Info:");
            console.log(fullUrl);
            console.log(token);
            console.info(postObj);
            console.groupEnd();
            //let fullUrl = 'https://jsonplaceholder.typicode.com/users';
            const response = await axios.post(fullUrl, postObj, config);
            if (HttpHelpers.HttpStatusOk(response.status))
            {
                return {"httpStatusCode": response.status, "hasError": false, "messages": response.data.messages, "dataResult": response.data};
            }
            else 
            {
                var errMsgs = [response.statusText];
                errMsgs.push(response.data.messages);
                return {"httpStatusCode": response.status, "hasError": true, "messages": errMsgs, "dataResult": response.data};
            }
;        }
        catch(err){
            return {"httpStatusCode": "", "hasError": true, "messages": [err.name, err.message], "dataResult": null};
        }
        finally{

        }

    }


    static async fetchJson(domain, url, token) {
        try {
            var config = {
                method: 'GET'
            }
            if (token) {
                config = {
                    method: 'GET',
                    headers: {
                        "Authorization": "bearer " + token
                    }
                }
            }
            var fullUrl = domain + url;
            //let fullUrl = 'https://jsonplaceholder.typicode.com/users';
            const response = await axios(fullUrl, config);
            if (HttpHelpers.HttpStatusOk(response.status))
            {
                return {"httpStatusCode": response.status, "hasError": false, "messages": response.data.messages, "dataResult": response.data};
            }
            else 
            {
                var errMsgs = [response.statusText];
                errMsgs.push(response.data.messages);
                return {"httpStatusCode": response.status, "hasError": true, "messages": errMsgs, "dataResult": response.data};
            }
        }
        catch(err){
            return {"httpStatusCode": "", "hasError": true, "messages": [err.name, err.message], "dataResult": null};
        }
        finally{

        }
    }




}